module.exports = __webpack_public_path__ + "img/50.2f1948d3.webp";